"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _ProviderSignupPage = _interopRequireDefault(require("../components/ProviderSignupPage"));

var _ProviderSignupFields = _interopRequireDefault(require("../constants/providerSignup/ProviderSignupFields"));

var _ProviderSignupActions = require("../actions/ProviderSignupActions");

var _react = _interopRequireWildcard(require("react"));

var _withUsageTracking = _interopRequireDefault(require("./hocs/withUsageTracking"));

var ProviderSignupContainer = _react.default.createClass({
  displayName: "ProviderSignupContainer",
  propTypes: {
    location: _react.PropTypes.object.isRequired,
    onClickErrorModalClose: _react.PropTypes.func.isRequired,
    onProviderSignupFieldChange: _react.PropTypes.func.isRequired,
    providerSignup: _react.PropTypes.object.isRequired,
    submitProviderSignupForm: _react.PropTypes.func.isRequired,
    trackPageview: _react.PropTypes.func.isRequired
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var queryParams = this.props.location.query;
    this.prefillFieldFromQueryParams(_ProviderSignupFields.default.FIRST_NAME, queryParams.firstname);
    this.prefillFieldFromQueryParams(_ProviderSignupFields.default.LAST_NAME, queryParams.lastname);
    this.prefillFieldFromQueryParams(_ProviderSignupFields.default.WEBSITE, queryParams.website);
    this.prefillFieldFromQueryParams(_ProviderSignupFields.default.CONTACT_EMAIL, queryParams.email);
  },
  componentDidMount: function componentDidMount() {
    this.props.trackPageview('provider-signup');
  },
  prefillFieldFromQueryParams: function prefillFieldFromQueryParams(field, inputText) {
    this.props.onProviderSignupFieldChange(field, inputText);
  },
  render: function render() {
    var providerSignup = this.props.providerSignup;
    return _react.default.createElement(_ProviderSignupPage.default, {
      onClickErrorModalClose: this.props.onClickErrorModalClose,
      providerSignup: providerSignup,
      onProviderSignupFieldChange: this.props.onProviderSignupFieldChange,
      submitProviderSignupForm: this.props.submitProviderSignupForm
    });
  }
});

function select(state) {
  return {
    providerSignup: state.providerSignup
  };
}

var ConnectedContainer = (0, _reactRedux.connect)(select, {
  onClickErrorModalClose: _ProviderSignupActions.onClickErrorModalClose,
  onProviderSignupFieldChange: _ProviderSignupActions.onProviderSignupFieldChange,
  submitProviderSignupForm: _ProviderSignupActions.submitProviderSignupForm
})(ProviderSignupContainer);

var _default = (0, _withUsageTracking.default)()(ConnectedContainer);

exports.default = _default;
module.exports = exports.default;